export default {
  header: {
    title: '注文内容の確認',
    alt: '確認/修正'
  },
  inEdit: '編集中',
  submit: 'この内容で注文する',
  ordersInfo: '注文情報',
  customerInfo: 'ご注文者情報',
  name: 'お名前',
  nameKana: 'フリガナ',
  tel: '電話番号',
  email: 'メールアドレス',
  paymentInfo: 'お支払い情報',
  paymentType: 'お支払い方法',
  card: 'カード決済',
  cardNo: 'カード番号',
  deliveryInfo: '配送情報',
  deliveryPreferredDate: '配送到着希望日',
  deliveryPreferredTime: '配送到着希望時間',
  preferredOff: '指定しない(最短でのお届け)',
  bank: '銀行振込',
  transferFee: '振込手数料',
  transferFeeNote: 'お客様ご負担',
  payerName: '振込時依頼人名',
  transferAccount: '振込口座',
  transferAccountNote: 'ご注文完了後、請求書発行Eメールにてお知らせ',
  transferDate: '振込期日',
  transferDateNote: 'ご注文完了から1ヶ月以内',
  deliveryDate: '配送日',
  deliveryDateNote: '着金確認後に発送',
  edit: '編集する',
  licence: '利用規約',
  agreeToLicence: 'に同意する',
  disagreeToLicenceDialog: '同意しない',
  agreeToLicenceDialog: '同意する',
  agreementNotes1:
    'ご注文完了後のキャンセル・返品・交換はお請けしておりません。',
  agreementNotes2:
    'お届け先の長期不在、該当住所不明などで商品のお届けができない場合、差出人様に商品返送となります。何卒ご了承ください。'
};



// WEBPACK FOOTER //
// ./src/i18n/ja/orderAggregators/confirmation.js